<template>
  <div class="map-continer">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2540.3311558084292!2d30.596455955013383!3d50.4535577862344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cfef93978f79%3A0x46445c76e08e1012!2z0YPQuy4g0JzQuNGC0YDQvtC_0L7Qu9C40YLQsCDQkNC90LTRgNC10Y8g0KjQtdC_0YLQuNGG0YzQutC-0LPQviwgNCwg0JrQuNC10LIsIDAyMDAw!5e0!3m2!1sru!2sua!4v1582215971922!5m2!1sru!2sua"
      frameborder="0"
      width="100%"
      height="100%"
      style="border: 0"
      allowfullscreen=""
    ></iframe>
    <!-- <l-map
      :zoom="zoom"
      :center="center"
      style="height: 100%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution"> </l-tile-layer>
      <l-marker :lat-lng="marker">
        <l-popup> <div>FUCK</div> </l-popup>
      </l-marker>
    </l-map> -->
  </div>
</template>
<script>
import { latLng, Icon } from 'leaflet'
// import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'

import 'leaflet/dist/leaflet.css'
export default {
  name: 'Map',
  props: {
    model: Object
  },
  components: {
    // LMap,
    // LTileLayer,
    // LMarker,
    // LPopup
  },
  data: () => ({
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    zoom: 13,
    center: latLng(50.45327825060288, 30.59829084054424),
    currentZoom: 11.5,
    currentCenter: latLng(50.45327825060288, 30.59829084054424),
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    marker: latLng(50.45327825060288, 30.59829084054424)
  }),

  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    }
  },
  created() {
    delete Icon.Default.prototype._getIconUrl
    Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    })
  }
}
</script>
<style lang="scss" scoped>
.map-continer {
  height: 600px;
}
</style>
